import { updateDialog } from '@Containers/Dialogs/DialogsActions';

import { typeOfLoginPromptDialog } from './LoginPromptDialogConstants';

// eslint-disable-next-line import/prefer-default-export
export function open() {
  return updateDialog({
    id: typeOfLoginPromptDialog,
    movable: false,
    size: 'md',
    dialogType: typeOfLoginPromptDialog,
  });
}
